import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface BackButtonProps {
    onClick: () => void;
}

const BackButton = ({ onClick }: BackButtonProps) => {
    return (
        <Button
            className="back-button"
            type="text"
            icon={<LeftOutlined />}
            onClick={onClick}
            aria-label="Ortga"
        />
    );
};

export default BackButton;
